import React from 'react'
// libs
import styled from 'styled-components'
import { isDesktop } from 'react-device-detect'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// icons
import FileDownload from '@mui/icons-material/FileDownload'
// themes
import colors from 'themes/colors'
// utils
import { darken } from 'polished'

export const IconWrapper = styled.div`
  align-items: center;
  border-radius: 22px;
  display: flex;
  min-height: 40px;
  justify-content: center;
  min-width: 40px;
  cursor: pointer;

  &:hover {
    background-color: ${darken(0.1, colors.darkBlue400)};
  }

  background-color: ${colors.darkBlue400};

  path {
    fill: ${colors.white};
  }
`

interface Props {
  loading?: boolean
  onClick?: React.MouseEventHandler
}

const TriggerButton: React.FC<Props> = ({ loading, onClick }) =>
  isDesktop ? (
    <Button type='button' layout={BUTTON_LAYOUTS.DARK_BLUE} isLoading={loading} onClick={onClick}>
      Export
    </Button>
  ) : (
    <IconWrapper onClick={onClick}>
      <FileDownload />
    </IconWrapper>
  )

export default TriggerButton
